module.exports = __webpack_public_path__ + "static/media/lt-surge-max.503add15.wav";